$(".testi__items").slick({
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                pauseOnHover: false,
            },
        },
    ],
});

$('.testi__btn_left').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.testi__btn_right').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');

});


function myMap() {
    var mapProp = {
        center: new google.maps.LatLng(51.508742, -0.120850),
        zoom: 5,
    };
    var map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
}
   fetch("https://goldapi.deuslab.com/?function=grain_value&key=pepe",{
    method:"GET"
  }).then(res=>{
    return res.json()
  }).then(res=>{
     console.log(res.data)
     $("#chartDate").text(res.data.au.date)
     $("#chartSymbol").text(res.data.au.currency_symbol)
     $("#chartValue").text(` ${res.data.au.value}/gr`)
     $("#chartDate2").text(res.data.ag.date)
     $("#chartSymbol2").text(res.data.ag.currency_symbol)
     $("#chartValue2").text(` ${res.data.ag.value}/gr`)
     $("#chartDate3").text(res.data.pd.date)
     $("#chartSymbol3").text(res.data.pd.currency_symbol)
     $("#chartValue3").text(` ${res.data.pd.value}/gr`)
  }).catch(err=>{
    console.log(err,"ERROR")
  })
$("#custom-h1").text("HELLO WORLD");